import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const PROMOTIONS_NAMESPACE_TOKEN = new InjectionToken<string | Observable<string>>(
  '[Promotions]: token for namespace (e.g. accountGroupId)',
);
